/** SignoffList.jsx - who signed what, and when. */
import { AMBER_TEXT, GREY, GREY_LIGHT, HAIRLINE, INK, RULE, SUBLABEL } from './theme';
import { fmtDate } from './helpers';
import { Mark } from './Primitives';

export function SignoffValue({ signoff }) {
  const base = {
    fontSize: 11.5,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    letterSpacing: '0.3px',
    fontVariantNumeric: 'tabular-nums',
  };
  if (signoff.status === 'done') {
    return (
      <span style={{ ...base, color: INK }}>
        <span style={{ fontWeight: 800 }}>{signoff.initials || 'Signed'}</span>
        {signoff.date ? <span style={{ color: GREY, marginLeft: 8 }}>{fmtDate(signoff.date)}</span> : null}
      </span>
    );
  }
  if (signoff.status === 'na') {
    return (
      <span style={{ ...base, color: AMBER_TEXT }}>
        <span style={{ fontWeight: 800 }}>N/A</span>
        {signoff.initials ? <span style={{ color: GREY, marginLeft: 8 }}>{signoff.initials}</span> : null}
        {signoff.date ? <span style={{ color: GREY, marginLeft: 8 }}>{fmtDate(signoff.date)}</span> : null}
      </span>
    );
  }
  return (
    <span
      style={{
        ...base,
        fontSize: 9.5,
        fontWeight: 800,
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        color: GREY_LIGHT,
      }}
    >
      Pending
    </span>
  );
}

export function SignoffRow({ signoff, last }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 10,
        flexWrap: 'wrap',
        padding: '7px 0',
        borderBottom: last ? 'none' : '1px solid ' + HAIRLINE,
      }}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 9,
          flex: '1 1 160px',
          minWidth: 0,
        }}
      >
        <span style={{ marginTop: 4, display: 'flex' }}>
          <Mark status={signoff.status} />
        </span>
        <span
          style={{
            fontSize: 12.5,
            color: INK,
            lineHeight: 1.45,
            fontWeight: 500,
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          {signoff.text}
        </span>
      </span>
      <SignoffValue signoff={signoff} />
    </div>
  );
}

export function SignoffList({ signoffs }) {
  const done = signoffs.filter((s) => s.status === 'done' || s.status === 'na').length;
  return (
    <div style={{ marginTop: 14 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 10,
          paddingBottom: 5,
          borderBottom: '1px solid ' + RULE,
        }}
      >
        <span style={{ ...SUBLABEL, color: GREY }}>Sign-off milestones</span>
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            color: GREY_LIGHT,
            flexShrink: 0,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {done}/{signoffs.length}
        </span>
      </div>
      {signoffs.map((signoff, i) => (
        <SignoffRow key={i} signoff={signoff} last={i === signoffs.length - 1} />
      ))}
    </div>
  );
}

/* ---------------------------- zones and disciplines --------------------------- */
